import { renderPage } from "renderPage"
import { AccountAdvertIndexPage } from "./Page"

renderPage({ component: AccountAdvertIndexPage })
